import { FetchAPI, ParamsSerializer } from './auth-service';

const fields = [
    {
        variable: 'name',
        hidden: false,
        headerName: 'Role',
        field: 'name',
        defaultSort: 'asc',
        type: 'string',
    },
    {
        variable: 'description',
        hidden: false,
        headerName: 'Description',
        field: 'description',
        type: 'string',
    },
    {
        variable: 'access',
        hidden: false,
        headerName: 'Type',
        field: 'access',
        type: 'string',
    },
    {
        variable: 'users',
        hidden: false,
        headerName: 'Users',
        field: 'user_sample',
        type: 'string',
        sortable: false,
    },
];

class RolesDataService {
    constructor () {
        // we only need one of these
        if (!RolesDataService.instance) {
            RolesDataService.instance = this;
        }
        this.searchPlaceholder = 'Search roles';
        this.fields = fields;

        this.getRoles = (search, query) => {
            let params = { limit: 10000 };
            if (query) {
                params = {
                    ...params,
                    sort: `${query.orderBy.variable}:${query.orderDirection}`,
                    offset: query.page * query.pageSize,
                    q: search || '',
                };
            } else if (search) {
                params = {
                    ...params,
                    q: search
                };
            }
            return FetchAPI({ method: 'GET', url: `roles/?${ParamsSerializer(params)}` })
                .then(res => {
                    if (!res) res = { objects: [] };
                    self.asof = res.timestamp;
                    this.data = res.objects || [];

                    return {
                        data: this.data,
                        page: query ? query.page : 1,
                        totalCount: this.total || (res.objects || []).length,
                    };
                });
        };

        this.getSavedSearches = () => {
            try {
                let searches = localStorage.getItem('savedSearches_roles') || '[]';
                if (searches.length < 1) searches = '[]';
                return JSON.parse(searches);
            } catch (err) {
                console.log('getSavedSearches error', err);
                return [];
            }
        };

        this.saveSearch = (str) => {
            if (!str || !str.length) return;
            const searches = this.getSavedSearches();
            const i = searches.findIndex(s => s === str);
            if (i >= 0) searches.splice(i, 1);
            searches.unshift(str);
            searches.splice(5);
            localStorage.setItem('savedSearches_roles', JSON.stringify(searches));
        };

        this.createRole = (data) => {
            return FetchAPI({
                method: 'POST',
                url: 'roles/',
                body: data,
            });
        };

        this.getRole = (rolename) => {
            return FetchAPI({
                method: 'GET',
                url: `roles/${rolename}`,
            });
        };

        this.updateRole = (rolename, data) => {
            return FetchAPI({
                method: 'PUT',
                url: `roles/${rolename}`,
                body: data,
            });
        };

        this.deleteRole = (rolename) => {
            return FetchAPI({
                method: 'DELETE',
                url: `roles/${rolename}`,
            });
        };

        return RolesDataService.instance;
    }
}

const RolesService = new RolesDataService();

export {
    RolesService as default,
    fields as roleFields,
};
